export default __webpack_public_path__ + "public/assets/images/1df0c4e37478adecde600ade1c36d0ad.png";